module.exports = __webpack_public_path__ + "img/sld_inverter_green_t1_green.18f09a7b.svg";